const setUpMixins = ({ Vue, router, vuetify, cashierConfigs, store }: any): void => {
  Vue.mixin({
    methods: {
      $routeChange: (path: string): void => {
        if (router.currentRoute.path !== path) {
          router.push(path)
          window.scrollTo({top: 0})
        }
      },
      $cashierConfigs: (type: string, customConfigs: any = {}, configsToMerge: string[] | undefined): void => {
        cashierConfigs.setCustomConfig(customConfigs)
        cashierConfigs[type](configsToMerge)
      }
    },
    computed: {
      $smallScreen () {
        return vuetify.smAndDown
      }
    }
  })
}

export default setUpMixins
